import {CHESTS} from "../constants/chests";
import {INVENTORY_ITEMS} from "../constants/inventoryItems";
import {BACKGROUND_ATTENTION_COLOR_GOLD, COINS_COLOR, PRIMARY_COLOR, RUBY_COLOR} from "../styles/constants";
import {COLORS_CONFIG, PLAYER_COLORS} from "./colors";

// TODO: Продумать и реализовать логику на случай,
//  когда у пользователя уже есть все предметы выпавшего типа

export const MATCH_REWARD_CHEST_CONFIGS = [{
  id: CHESTS.WOODEN,
  rewards: [{
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 10, max: 50},
    chance: 90
  }, {
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 50, max: 150},
    chance: 9
  }, {
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 150, max: 500},
    chance: 1
  }]
}, {
  id: CHESTS.BRONZE,
  rewards: [{
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 50, max: 150},
    chance: 85
  }, {
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 150, max: 500},
    chance: 9
  }, {
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 500, max: 1000},
    chance: 3
  }, {
    itemType: INVENTORY_ITEMS.FACTION_SKIN,
    chance: 3
  }]
}, {
  id: CHESTS.SILVER,
  rewards: [{
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 150, max: 500},
    chance: 80
  }, {
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 500, max: 1000},
    chance: 10
  }, {
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 1000, max: 1500},
    chance: 5
  }, {
    itemType: INVENTORY_ITEMS.FACTION_SKIN,
    chance: 5
  }]
}, {
  id: CHESTS.GOLD,
  rewards: [{
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 500, max: 1000},
    chance: 71
  }, {
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 1000, max: 1500},
    chance: 10
  }, {
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 1500, max: 2500},
    chance: 5
  }, {
    itemType: INVENTORY_ITEMS.FACTION_UNIT_SKIN,
    chance: 7
  }, {
    itemType: INVENTORY_ITEMS.FACTION_SKIN,
    chance: 7
  }]
}, {
  id: CHESTS.DIAMOND,
  rewards: [{
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 1000, max: 1500},
    chance: 55
  }, {
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 1500, max: 2500},
    chance: 10
  }, {
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 2500, max: 5000},
    chance: 5
  }, {
    itemType: INVENTORY_ITEMS.FACTION_UNIT_SKIN,
    chance: 10
  }, {
    itemType: INVENTORY_ITEMS.FACTION_SKIN,
    chance: 10
  }, {
    itemType: INVENTORY_ITEMS.CRYSTALS,
    count: {min: 5, max: 20},
    chance: 5
  }, {
    itemType: INVENTORY_ITEMS.PREMIUM,
    count: {min: 1, max: 3},
    chance: 5
  }]
}, {
  id: CHESTS.RUBY,
  rewards: [{
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 1500, max: 2500},
    chance: 37
  }, {
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 2500, max: 5000},
    chance: 10
  }, {
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 5000, max: 10000},
    chance: 5
  }, {
    itemType: INVENTORY_ITEMS.FACTION_UNIT_SKIN,
    chance: 15
  }, {
    itemType: INVENTORY_ITEMS.FACTION_SKIN,
    chance: 15
  }, {
    itemType: INVENTORY_ITEMS.CRYSTALS,
    count: {min: 10, max: 50},
    chance: 10
  }, {
    itemType: INVENTORY_ITEMS.PREMIUM,
    count: {min: 1, max: 7},
    chance: 5
  }, {
    itemType: INVENTORY_ITEMS.FACTION,
    chance: 3
  }]
}, {
  // Божественный — примерно вдвое богаче рубинового: диапазоны нуменов,
  // кристаллов и дней премиума удвоены, шансы предметов не ниже рубиновых.
  // Ожидание нуменов за сундук ≈ 2970 против 1490 у рубинового
  // (npm run validate:chests)
  id: CHESTS.GOD,
  rewards: [{
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 3000, max: 5000},
    chance: 33
  }, {
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 5000, max: 10000},
    chance: 10
  }, {
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 10000, max: 20000},
    chance: 6
  }, {
    itemType: INVENTORY_ITEMS.FACTION_UNIT_SKIN,
    chance: 16
  }, {
    itemType: INVENTORY_ITEMS.FACTION_SKIN,
    chance: 16
  }, {
    itemType: INVENTORY_ITEMS.CRYSTALS,
    count: {min: 20, max: 100},
    chance: 10
  }, {
    itemType: INVENTORY_ITEMS.PREMIUM,
    count: {min: 2, max: 14},
    chance: 5
  }, {
    itemType: INVENTORY_ITEMS.FACTION,
    chance: 4
  }]
}]

export const SHOP_CHEST_CONFIGS = [{
  id: CHESTS.RANDOM_DEFAULT,
  name: 'Сундук Авантюриста',
  priceCrystals: 99,
  discountPercentsFor10ItemsPurchase: 10,
  dailyRewardTextColor: COINS_COLOR,
  rewards: [{
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 5000, max: 20000},
    chance: 80
  }, {
    itemType: INVENTORY_ITEMS.FACTION_SKIN,
    chance: 5
  }, {
    itemType: INVENTORY_ITEMS.FACTION_UNIT_SKIN,
    chance: 5
  }, {
    itemType: INVENTORY_ITEMS.CRYSTALS,
    count: {min: 100, max: 500},
    chance: 5
  }, {
    itemType: INVENTORY_ITEMS.FACTION,
    chance: 5
  }]
}, {
  id: CHESTS.RANDOM_EPIC,
  name: 'Сундук Патриция',
  priceCrystals: 199,
  discountPercentsFor10ItemsPurchase: 15,
  dailyRewardTextColor: COINS_COLOR,
  rewards: [{
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 10000, max: 50000},
    chance: 60
  }, {
    itemType: INVENTORY_ITEMS.FACTION_SKIN,
    chance: 10
  }, {
    itemType: INVENTORY_ITEMS.FACTION_UNIT_SKIN,
    chance: 10
  }, {
    itemType: INVENTORY_ITEMS.CRYSTALS,
    count: {min: 100, max: 750},
    chance: 10
  }, {
    itemType: INVENTORY_ITEMS.FACTION,
    chance: 10
  }]
}, {
  id: CHESTS.RANDOM_LEGENDARY,
  name: 'Сундук Императора',
  priceCrystals: 590,
  discountPercentsFor10ItemsPurchase: 20,
  backgroundColor: BACKGROUND_ATTENTION_COLOR_GOLD,
  shadowColor: COINS_COLOR,
  modalTextColor: COINS_COLOR,
  rewards: [{
    itemType: INVENTORY_ITEMS.FACTION_SKIN,
    chance: 15
  }, {
    itemType: INVENTORY_ITEMS.FACTION_UNIT_SKIN,
    chance: 15
  }, {
    itemType: INVENTORY_ITEMS.CRYSTALS,
    count: {min: 100, max: 1000},
    chance: 20
  }, {
    itemType: INVENTORY_ITEMS.PREMIUM,
    count: {min: 7, max: 14},
    chance: 25
  }, {
    itemType: INVENTORY_ITEMS.FACTION,
    chance: 25
  }]
}, {
  id: CHESTS.ETERNAL,
  name: 'Сундук Вечности',
  priceCrystals: 14900,
  backgroundColor: PRIMARY_COLOR,
  shadowColor: RUBY_COLOR,
  modalTextColor: PRIMARY_COLOR,
  rewards: [{
    itemType: INVENTORY_ITEMS.ALL_FACTIONS,
    chance: 100
  }]
}, {
  id: CHESTS.SKINS_IRON,
  name: 'Железный Сундук Обличий',
  priceNumens: 690,
  textColor: COLORS_CONFIG[PLAYER_COLORS.LIGHT_BROWN],
  shadowColor: COLORS_CONFIG[PLAYER_COLORS.LIGHT_BROWN],
  rewards: [{
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 10, max: 700},
    chance: 95
  }, {
    itemType: INVENTORY_ITEMS.FACTION_SKIN,
    chance: 5
  }]
}, {
  id: CHESTS.SKINS_SILVER,
  name: 'Серебряный Сундук Обличий',
  priceNumens: 1990,
  rewards: [{
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 100, max: 2000},
    chance: 85
  }, {
    itemType: INVENTORY_ITEMS.FACTION_SKIN,
    chance: 15
  }]
}, {
  id: CHESTS.SKINS_GOLD,
  name: 'Золотой Сундук Обличий',
  priceNumens: 4990,
  textColor: COINS_COLOR,
  shadowColor: COINS_COLOR,
  rewards: [{
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 100, max: 5000},
    chance: 60
  }, {
    itemType: INVENTORY_ITEMS.FACTION_SKIN,
    chance: 40
  }]
}, {
  id: CHESTS.UNIT_SKINS_IRON,
  name: 'Железный Сундук Знамён',
  priceNumens: 1490,
  textColor: COLORS_CONFIG[PLAYER_COLORS.LIGHT_BROWN],
  shadowColor: COLORS_CONFIG[PLAYER_COLORS.LIGHT_BROWN],
  rewards: [{
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 10, max: 100},
    chance: 95
  }, {
    itemType: INVENTORY_ITEMS.FACTION_UNIT_SKIN,
    chance: 5
  }]
}, {
  id: CHESTS.UNIT_SKINS_SILVER,
  name: 'Серебряный Сундук Знамён',
  priceNumens: 3990,
  rewards: [{
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 100, max: 4000},
    chance: 85
  }, {
    itemType: INVENTORY_ITEMS.FACTION_UNIT_SKIN,
    chance: 15
  }]
}, {
  id: CHESTS.UNIT_SKINS_GOLD,
  name: 'Золотой Сундук Знамён',
  priceNumens: 7490,
  textColor: COINS_COLOR,
  shadowColor: COINS_COLOR,
  rewards: [{
    itemType: INVENTORY_ITEMS.NUMENS,
    count: {min: 100, max: 7500},
    chance: 65
  }, {
    itemType: INVENTORY_ITEMS.FACTION_UNIT_SKIN,
    chance: 35
  }]
}]

export const TUTORIAL_CHEST_CONFIGS = [{
  id: CHESTS.TUTORIAL_SKINS_GOLD,
  name: 'Золотой Сундук Обличий',
  priceCrystals: 3990,
  // discountPercentsFor10ItemsPurchase: 10,
  // textColor — цвет названия сундука (модалка завершения главы обучения и
  // прочие витрины), dailyRewardTextColor — только для ежедневных наград
  textColor: COINS_COLOR,
  dailyRewardTextColor: COINS_COLOR,
  rewards: [{
    itemType: INVENTORY_ITEMS.FACTION_SKIN_IMPLEMENTED,
    chance: 100
  }]
}];

export const ALL_CHEST_CONFIGS = [...MATCH_REWARD_CHEST_CONFIGS, ...SHOP_CHEST_CONFIGS, ...TUTORIAL_CHEST_CONFIGS]